// localhost points to the phone itself; use the development computer's LAN address.
// export const API_URL = "http://192.168.88.254:8000/api/"
export const API_URL = "https://api.azcool2.net/api/"
